import { useMemo, useState } from 'react';
import { OptionKey, PlanStatuses, usePaginationParams } from '@common-fe/common-fe';

import { ALL_OPTION } from '@/common/constants';
import { DefaultSortTypesEnum } from '@/common/types';
import { useAllOptionsToggle, useCurrentOrganization } from '@/modules/core/hooks';
import { handleAllToggle } from '@/modules/core/hooks/useAllOptionsToggle';
import { useGetOrganizationPlansQuery } from '@/modules/employee/Employee/queries/useGetOrganizationPlans.query';

import { useScheduledContributionRecordsFiltersStore } from '../../stores';
import useScheduledContributionStore from '../../stores/useScheduledContribution.store';
import useScheduledContributionRecordsQuery from '../queries/useScheduledContributionRecords.query';
const DEFAULT_PER_PAGE = 10;

const useScheduledContributionRecords = () => {
  const {
    observingOrganization: { id: orgId },
  } = useCurrentOrganization();
  const [sortBy, setSortBy] = useState<OptionKey>(DefaultSortTypesEnum.ASC);
  const currentAccounts = useScheduledContributionRecordsFiltersStore((state) => state.state.currentAccounts);
  const setCurrentAccounts = useScheduledContributionRecordsFiltersStore((state) => state.setState);
  const setSearchStringInStore = useScheduledContributionRecordsFiltersStore((state) => state.setState);
  
  const { options: accountsOptions } = useGetOrganizationPlansQuery(
    orgId,
    [PlanStatuses.ACTIVE, PlanStatuses.PENDING_TERMINATION, PlanStatuses.TERMINATION_IN_PROGRESS],
  );
  const computedSelectedAccounts = useAllOptionsToggle(currentAccounts || [ALL_OPTION.value]);
  const filteredOptions = useMemo(
    () => computedSelectedAccounts.filter((item) => item !== ALL_OPTION.value),
    [computedSelectedAccounts]
  );
  
  const handleSetCurrentAccounts = (value: OptionKey[]) => {
    const processedValue = handleAllToggle(value);
    setCurrentAccounts({ currentAccounts: processedValue });
  };
  const { page, setPage, setPerPage, perPage, currentSearch, searchString, setSearchString } =
    usePaginationParams(DEFAULT_PER_PAGE);

  const handleSetSearchString = (value: string) => {
    setSearchString(value);
    setSearchStringInStore({ searchString: value });
  };

  const calendarId = useScheduledContributionStore((state) => state.state.calendarId);
  const startDate = useScheduledContributionStore((state) => state.state.startDate);

  const { formattedData, total, isLoading } = useScheduledContributionRecordsQuery({
    calendarId: calendarId || '',
    startDate,
    currentAccounts: filteredOptions,
    searchString: currentSearch,
    page: page - 1 || 0,
    perPage,
    sortBy
  });

  return {
    isLoading,
    total,
    data: formattedData,
    accountsOptions,
    currentAccounts: computedSelectedAccounts,
    setCurrentAccounts: handleSetCurrentAccounts,
    page,
    setPage,
    perPage,
    searchString,
    setSearchString: handleSetSearchString,
    setPerPage,

    sortBy,
    setSortBy,

  };
};

export default useScheduledContributionRecords;
